// Environment configuration
import { getCurrentEnvironment, getFullUrl, getShareUrl } from './environments';

const env = getCurrentEnvironment();

// Base URLs
export const BASE_URL = env.baseUrl;
export const API_BASE_URL = env.apiBaseUrl;
export const BASENAME = env.basename;

// Cookie settings
export const COOKIE_DOMAIN = env.cookieDomain;

// Headers
export const DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
  'X-Forwarded-Host': env.forwardedHost,
  'X-Forwarded-Proto': env.forwardedProto,
  'X-ThermalX-Frontend': 'true',
  'Accept': 'application/json, text/plain, */*'
};

// Auth URLs
export const LOGIN_URL = getFullUrl('/login');
export const LOGOUT_URL = getFullUrl('/login');

// Static assets base URL
export const STATIC_URL = BASE_URL;

// Environment info for debugging
export const ENVIRONMENT_INFO = {
  nodeEnv: process.env.NODE_ENV,
  reactAppEnv: process.env.REACT_APP_ENV,
  environment: env.name,
  basename: BASENAME,
  baseUrl: BASE_URL,
  apiBaseUrl: API_BASE_URL
};

// Helper functions
export { getFullUrl, getShareUrl }; 